// Pure cents-only invoice arithmetic shared by mock invoiceCalc and UI
// consumers (InvoiceDetailPanel / InvoicePreviewOverlay / AddInvoiceForm).
// Keep this file dependency-free so UI can import without pulling mock code.

type LineComputableItem = {
  qty: number
  rateCents?: number
  discountPercent?: number
  amountCents?: number
}

export function computeLineTotalCents(item: LineComputableItem): number {
  // Server-computed `amountCents` wins — backend applies per-product
  // multipliers (annual / quarterly / monthly) the client can't reproduce.
  if (typeof item.amountCents === 'number') return item.amountCents
  const rate = item.rateCents ?? 0
  const qty = item.qty ?? 0
  const discount = item.discountPercent ?? 0
  return Math.round(rate * qty * (1 - discount / 100))
}

export function computeSubtotalCents(items: LineComputableItem[] | undefined): number {
  if (!items) return 0
  return items.reduce((sum, item) => sum + computeLineTotalCents(item), 0)
}
